export let FileAwarenessModalStep = /*#__PURE__*/function (FileAwarenessModalStep) {
  FileAwarenessModalStep["DELETE_MODAL"] = "delete_modal";
  FileAwarenessModalStep["DELETE_IN_PROGRESS_MODAL"] = "delete_in_progress_modal";
  FileAwarenessModalStep["KEEP_FILES_IN_USE_MODAL"] = "keep_files_in_use_modal";
  return FileAwarenessModalStep;
}({});
//# sourceMappingURL=modalSteps.js.map